<template>
  <v-dialog v-model="value" persistent max-width="800">
    <v-card>
      <v-card-title class="primary modal-title justify-space-between" primary-title>
        {{ titulo }}
        <v-btn class="close__button" text @click="fecharModal" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="modal-banner-container">
        <p class="align-start">
          {{ motivo }}
        </p>
      </v-card-text>
      <v-card-actions class="acoes justify-space-between">
        <v-btn class="ml-3" color="#777" flat @click="fecharModal">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalVerMotivoNaoCredenciamento',
  props: {
    value: {
      default: () => {
        return {}
      }
    },
    titulo: String,
    motivo: String
  },
  methods: {
    fecharModal() {
      this.$emit('fecharModalNaoCredenciamento')
    },
  }
}
</script>

<style scoped lang="stylus">

.modal-banner-container
  overflow-x hidden
  text-align center
  padding 20px

.close__button
  color #fff !important

.align-start
  text-align justify !important

</style>
